export default __webpack_public_path__ + "static/Blockchain-App-Development-Company-0f7cf890baf1875c85676ce8ebcf7551.webp";